import { format } from '@utils/string';
import { getProductsByCategoriesURL } from '@services/urls/apiGatewayURLs';

import { SHELVES_SECTIONS_MAX_QUANTITY } from '@shopDetails/constants';
import ServiceResponse from '../models/ServiceResponse';

const message = 'shopId param is required';

async function getCategoriesProducts({
  axios,
  categoryId,
  shopId,
  count = SHELVES_SECTIONS_MAX_QUANTITY,
}) {
  try {
    if (!shopId) return new ServiceResponse({ error: message });

    const url = format(
      getProductsByCategoriesURL,
      shopId,
      categoryId,
      count,
      0,
    );

    const { data } = await axios.get(url);

    const result = { [categoryId]: { ...data } };

    return new ServiceResponse({ data: result });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default getCategoriesProducts;
